import { type BackendFactory } from 'dnd-core';
import { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';

const isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints);

const DragAndDropWrapper = ({ children }: { children: React.ReactNode }) => {
  const [dndBackend, setDndBackend] = useState<BackendFactory | null>(null);

  useEffect(() => {
    const loadBackend = async () => {
      if (isTouchDevice) {
        const { TouchBackend } = await import('react-dnd-touch-backend');
        setDndBackend(() => TouchBackend({ enableMouseEvents: true }));
      } else {
        const { HTML5Backend } = await import('react-dnd-html5-backend');
        setDndBackend(() => HTML5Backend);
      }
    };

    loadBackend();
  }, []);

  if (!dndBackend) return null;

  return <DndProvider backend={dndBackend}>{children}</DndProvider>;
};

export default DragAndDropWrapper;
